import React, { useEffect } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import { useSelector } from "react-redux";

function DetailsCard() {
  const deviceData = useSelector((state) => state.deviceConfig.deviceData);
  const heatData = useSelector((state) => state.deviceConfig.heatData);
  const heatDetails = useSelector((state) => state.deviceConfig.heatDetails);
  useEffect(() => {
    console.log(deviceData, heatData, "deviceData and heatData in DetailsCard");
    console.log(heatDetails, "heatDetails in DetailsCard");
  }, [deviceData, heatData]);
  const fields = [
    { label: "Thing ID", value: heatDetails?.thingId || "" },
    { label: "Type", value: heatDetails?.type || "" },
    { label: "Channel", value: heatDetails?.channel || "" },
    { label: "Latitude", value: heatDetails?.latitude || "" },
    { label: "Longitude", value: heatDetails?.longitude || "" },
    {
      label: "Updated At",
      value: heatDetails?.updatedAt
        ? new Date(heatDetails?.updatedAt).toLocaleString()
        : "N/A",
    },
    {
      label: "Ignition",
      value: heatDetails?.ignition === 1 ? "ON" : "OFF" || "",
    },
    { label: "Latest RFID Time", value: heatDetails?.rfid || "" },
    { label: "Latest SOS Time", value: heatDetails?.sosTime || "" },
  ];

  return (
    deviceData &&
    heatDetails && (
      <MDBox
        sx={{
          p: 3,
          borderRadius: "12px",
          // boxShadow: "0px 4px 12px rgba(0,0,0,0.1)",
          maxWidth: 600,
          margin: "auto",
        }}
      >
        <MDTypography variant="h5" fontWeight="medium" gutterBottom>
          Device Details
        </MDTypography>

        <MDBox
          component="form"
          display="grid"
          gridTemplateColumns="1fr 1fr"
          gap={2}
        >
          {fields.map((field, index) => (
            <MDBox key={index} display="flex" flexDirection="column">
              <MDTypography variant="button" fontWeight="regular" mb={0.5}>
                {field.label}
              </MDTypography>
              <MDInput value={field.value} fullWidth size="small" readOnly />
            </MDBox>
          ))}
        </MDBox>
      </MDBox>
    )
  );
}

export default DetailsCard;